import React from 'react';
import { browserHistory } from 'react-router';
import GlobalHeader from '../../Fragments/GlobalHeader';

let QuoteError = require('../../Managers/QuoteError');

const ErrorRecoverable = React.createClass({

    handleClick: function() {
        QuoteError.clear();
        browserHistory.push('/start');
    },

    render() {
        let errors = QuoteError.get();
        return (
            <div>
                <GlobalHeader/>
                
                <div className="container stepless">
                    <h1>Please Correct The Following Issues</h1>
                    <ul>
                        <li>{errors.displayError}</li>
                    </ul>

                    <button className="btn btn-success" onClick={this.handleClick}>Go Back &amp; Correct Issues</button>
                </div>

            </div>
        );
    }
});

export default ErrorRecoverable;


/** WEBPACK FOOTER **
 ** ./src/components/Screens/Quote/ErrorRecoverable.js
 **/